<template>
  <div :class="rootClass">
    <Icon :name="iconName" class="mr-1" />
    <slot />
  </div>
</template>


<script>

import Icon from '../Icon'

export default {
  name: 'Step',

  components: { Icon },

  inject: [ 'Stepper' ],

  props: {
    position: Number
  },

  computed: {
    isActive () {
      return this.Stepper.activeStep === this.position
    },

    isDone () {
      return this.Stepper.activeStep > this.position
    },

    rootClass () {
      return [
        'text-primary',
        { [ 'text-primary' ]: (this.isActive || this.isDone) }
      ]
    },

    iconName () {
      return this.isDone ? 'dot-circle' : 'circle'
    }
  }
}

</script>
